import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

import { RichViewLogsDrawerWrapperStyled } from "../../rich-logs-components";

export const EtlViewLogsDrawerWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "drawer-etl-view-logs-wrapper",
  },
)<{ $isRtl: boolean }>`
  ${RichViewLogsDrawerWrapperStyled}
`;
